import * as Yup from 'yup';

export const investmentDetailsFormSchema = Yup.object().shape({
    investor: Yup.string().required('Required'),
    investment_type: Yup.string().required('Required'),
    currency: Yup.string().required('Required'),
    date_of_investment: Yup.string().required('Required'),
    amount: Yup.string().required('Required'),
});